<template>
  <v-layout column>
    <v-flex>
      <v-layout align-center>
        <h2
          v-if="compactMode"
          class="subheading font-weight-bold pr-1"
        >
          Отгрузки
        </h2>
        <v-btn
          v-if="!compactMode"
          small
          flat
          :color="isPhaseActive ? 'primary' : ''"
          @click="changePhaseActive"
        >
          Звенья
        </v-btn>
        <v-btn
          v-if="!compactMode"
          small
          flat
          :color="isReleaseOrderActive ? 'primary' : ''"
          @click="changeReleaseOrderActive"
        >
          Отгрузки
        </v-btn>
        <v-divider
          vertical
          class="mx-2"
        />
        <v-btn
          :disabled="disabledAdd"
          color="primary"
          small
          @click="editor = true"
        >
          Добавить
        </v-btn>
        <v-spacer />
        <v-flex xs3>
          <app-reference
            v-model="country"
            label="Направление*"
            :rules="[v => !!v || '']"
            :without-clearable="true"
            resource="countries"
            component-name="Country"
            :outline="true"
            :height-field="40"
            :disabled="!canEdit"
            @input="changeDirection"
          />
        </v-flex>
        <v-btn
          v-if="!compactMode"
          small
          icon
          :disabled="itemsLoading"
          class="mr-0"
          @click="changeCompactMode"
        >
          <v-icon>{{ compactMode ? "fullscreen_exit" : "fullscreen" }}</v-icon>
        </v-btn>
        <v-dialog
          v-if="editor"
          v-model="editor"
          width="1200"
          persistent
        >
          <v-card>
            <ReleaseOrder
              :id="editingItem ? editingItem.id : 0"
              v-model="editingItem"
              :is-shipping="true"
              :disabled="!canEdit"
              @close="closeEditor"
            />
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-data-table
        class="elevation-0"
        :loading="itemsLoading"
        :headers="headers"
        :items="filteredItems"
        :disabled="itemsLoading"
        hide-actions
        no-data-text="Нет данных"
      >
        <template
          slot="headers"
          slot-scope="props"
        >
          <tr class="text-xs-left px-3">
            <th
              v-for="(header, index) in props.headers"
              :key="index"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template
          slot="items"
          slot-scope="props"
        >
          <tr
            class="clickable-row"
            @click="readonly ? true : openEditor(props.item)"
          >
            <td>{{ props.item.id }}</td>
            <td>{{ props.item.author }}</td>
            <td>
              {{ props.item.releaseOrderFact ?
                props.item.releaseOrderFact : props.item.releaseOrderPlan ?
                  props.item.releaseOrderPlan : '' | date }}
            </td>
            <td>{{ props.item.shippingNumber }}</td>
            <td>{{ props.item.client }}</td>
            <td>{{ props.item.sender }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>
<script>
import ReleaseOrder from "../../../release-orders/ReleaseOrder.vue";
import mixin from "../../../../mixins/confirm-cancel-changes.js";
import { changeShippingDirection } from "../../../../backend/shippingsApi.js";
import { getReleaseOrder } from "../../../../backend/releaseOrdersApi.js";

export default {
  components: {
    ReleaseOrder,
  },
  mixins: [mixin],
  props: ["canEdit", "shippingId"],
  data() {
    return {
      editingItem: null,
      itemsLoading: false,
      editor: false,
      country: null,
    };
  },
  computed: {
    items: {
      get() {
        return this.$store.getters["shipping/releaseOrders"];
      },
      set(items) {
        return this.$store.commit("shipping/setReleaseOrders", items);
      },
    },
    filteredItems() {
      if (!this.compactMode) {
        return this.items.slice(0, 3);
      } else {
        return this.items;
      }
    },
    isFullReleaseOrder() {
      return this.items.find(i => i.isPartial === false) ? true : false;
    },
    isPhaseActive: {
      get() {
        return this.$store.getters["shipping/isPhaseActive"];
      },
      set(value) {
        return this.$store.commit("shipping/setIsPhaseActive", value);
      },
    },
    lastPhase() {
      return this.$store.getters["shipping/lastPhase"];
    },
    isReleaseOrderActive: {
      get() {
        return this.$store.getters["shipping/isReleaseOrderActive"];
      },
      set(value) {
        return this.$store.commit("shipping/setIsReleaseOrderActive", value);
      },
    },
    readonly() {
      return this.$store.getters["shipping/splitted"];
    },
    compactMode: {
      get() {
        return this.$store.getters["shipping/compactMode"];
      },
      set(value) {
        return this.$store.commit("shipping/setCompactMode", value);
      },
    },
    id() {
      return this.$store.getters["shipping/id"];
    },
    phases() {
      return this.$store.getters["shipping/phases"];
    },
    isFinalPhaseExist() {
      return this.phases.some(i => i.isLast);
    },
    disabledAdd() {
      return (
        this.itemsLoading ||
        this.readonly ||
        !this.lastPhase ||
        this.isFullReleaseOrder ||
        !this.canEdit ||
        !this.isFinalPhaseExist
      );
    },
    direction() {
      return this.$store.getters["shipping/direction"];
    },
    headers() {
      return this.$store.getters["shipping/releaseOrdersHeaders"];
    },
  },
  watch: {
    direction: {
      handler(value) {
        if (value) {
          this.country = { ...value };
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getItem(itemId) {
      this.itemsLoading = true;
      this.editingItem = await getReleaseOrder(itemId);
      this.itemsLoading = false;
    },
    async openEditor(value) {
      await this.getItem(value.id);
      this.editor = true;
    },
    closeEditor() {
      this.editingItem = null;
      this.editor = false;
      this.$store.dispatch("shipping/getReleaseOrders", this.shippingId);
    },
    changeCompactMode() {
      this.$store.commit("shipping/setCompactMode", !this.compactMode);
    },
    changePhaseActive() {
      this.$store.commit("shipping/setIsPhaseActive", true);
      this.$store.commit("shipping/setIsReleaseOrderActive", false);
    },
    changeReleaseOrderActive() {
      this.$store.commit("shipping/setIsPhaseActive", false);
      this.$store.commit("shipping/setIsReleaseOrderActive", true);
    },
    async changeDirection() {
      if (!this.country) {
        return;
      }
      const direction = await changeShippingDirection(this.id, this.country);
      this.$store.commit("shipping/setDirection", direction);
      this.showInfo("Направление изменено");
    },
  },
};
</script>
